import {
  AuthAccountOrganizationPlatformMessageSourceChoices,
  OrganizationPlatformMessageNode,
  PostHiringMessageDetail,
  PostHiringMessagesList,
} from "@cpj-ai/panel-npm-package";
import { useGetCooperationsPlatformMessagesQuery } from "@graphql/generated";
import { useMemo, useState } from "react";

interface ICPJMessagesTabContentProps {
  employeeId?: string;
}

const CPJMessagesTabContent = ({ employeeId }: ICPJMessagesTabContentProps) => {
  const [activeMessageId, setActiveMessageId] = useState<string>();

  const { data, loading } = useGetCooperationsPlatformMessagesQuery({
    variables: { id: employeeId ?? "" },
    skip: !employeeId,
  });

  const messages = useMemo(
    () =>
      (data?.organization?.employee?.get?.cooperations?.[0]?.platformMessages?.edges?.map((message) => ({
        id: message?.node?.id ?? "",
        title: message?.node?.title ?? "",
        text: message?.node?.text ?? "",
        created: message?.node?.created ?? "",
        readAt: message?.node?.readAt ?? "",
        source: message?.node?.source ?? AuthAccountOrganizationPlatformMessageSourceChoices.AI,
        attachments: [],
      })) ?? []) as unknown as OrganizationPlatformMessageNode[],
    [data?.organization?.employee?.get?.cooperations],
  );

  const activeMessage = useMemo(() => {
    return messages?.find((message) => message.id === activeMessageId);
  }, [activeMessageId, messages]);

  return (
    <div className="flex gap-6">
      <PostHiringMessagesList
        setActiveMessageId={setActiveMessageId}
        activeMessageId={activeMessageId}
        messages={messages}
        isLoading={loading}
      />
      {activeMessageId && <PostHiringMessageDetail message={activeMessage} />}
    </div>
  );
};

export default CPJMessagesTabContent;
